import * as React from "react";
import styled from "styled-components";

export const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(100px,200px));
  gap: 5px;
`;
export default ButtonGroup;